import moment from "moment";
import type { UserPreferences } from "../types/user-preferences";

/* eslint-disable import/no-unused-modules */
export interface Timezone {
  label: string;
  shortLabel: string;
  value: string;
}

export const getTimezoneOffset = (timezone: string): string => {
  const currentDate = moment.tz(new Date(), timezone);
  const utcOffset = currentDate.format("Z");
  return "GMT" + utcOffset;
};

export const getTimezoneShortLabel = (timezone: string): string | undefined => {
  return timezones.find((item) => item.value === timezone)?.shortLabel;
};

export const getCurrentTime = (
  timezone: string,
  userPreferences: UserPreferences,
): string => {
  const timeFormat =
    userPreferences.locale.time_format === "24h" ? "HH:mm" : "hh:mma";
  const currentDate = moment.tz(new Date(), timezone);
  return currentDate.format(timeFormat);
};

export const timezones: Timezone[] = [
  {
    label: "Line Islands Time (Pacific/Kiritimati)",
    shortLabel: "LINT",
    value: "Pacific/Kiritimati",
  },
  {
    label: "Chatham Daylight Time (Pacific/Chatham)",
    shortLabel: "CHADT",
    value: "Pacific/Chatham",
  },
  {
    label: "New Zealand Daylight Time (Pacific/Auckland)",
    shortLabel: "NZDT",
    value: "Pacific/Auckland",
  },
  {
    label: "Phoenix Islands Time (Pacific/Enderbury)",
    shortLabel: "PHOT",
    value: "Pacific/Enderbury",
  },
  {
    label: "Fiji Summer Time (Pacific/Fiji)",
    shortLabel: "FJT",
    value: "Pacific/Fiji",
  },
  {
    label: "Tonga Standard Time (Pacific/Tongatapu)",
    shortLabel: "TOT",
    value: "Pacific/Tongatapu",
  },
  {
    label: "Petropavlovsk-Kamchatski Standard Time (Asia/Kamchatka)",
    shortLabel: "PETT",
    value: "Asia/Kamchatka",
  },
  {
    label: "Norfolk Island Time (Pacific/Norfolk)",
    shortLabel: "NFT",
    value: "Pacific/Norfolk",
  },
  {
    label: "Lord Howe Daylight Time (Australia/Lord_Howe)",
    shortLabel: "LHST",
    value: "Australia/Lord_Howe",
  },
  {
    label: "Australian Eastern Daylight Time (Australia/Sydney)",
    shortLabel: "AEDT",
    value: "Australia/Sydney",
  },
  {
    label: "Solomon Islands Time (Pacific/Guadalcanal)",
    shortLabel: "SBT",
    value: "Pacific/Guadalcanal",
  },
  {
    label: "Australian Central Daylight Time (Australia/Adelaide)",
    shortLabel: "ACDT",
    value: "Australia/Adelaide",
  },
  {
    label: "Australian Eastern Standard Time (Australia/Brisbane)",
    shortLabel: "AEST",
    value: "Australia/Brisbane",
  },
  {
    label: "Australian Central Standard Time (Australia/Darwin)",
    shortLabel: "ACST",
    value: "Australia/Darwin",
  },
  {
    label: "Korean Standard Time (Asia/Seoul)",
    shortLabel: "KST",
    value: "Asia/Seoul",
  },
  {
    label: "Japan Standard Time (Asia/Tokyo)",
    shortLabel: "JST",
    value: "Asia/Tokyo",
  },
  {
    label: "Hong Kong Standard Time (Asia/Hong_Kong)",
    shortLabel: "HKT",
    value: "Asia/Hong_Kong",
  },
  {
    label: "Malaysia Time (Asia/Kuala_Lumpur)",
    shortLabel: "MST",
    value: "Asia/Kuala_Lumpur",
  },
  {
    label: "Philippine Standard Time (Asia/Manila)",
    shortLabel: "PHT",
    value: "Asia/Manila",
  },
  {
    label: "China Standard Time (Asia/Shanghai)",
    shortLabel: "CST",
    value: "Asia/Shanghai",
  },
  {
    label: "Singapore Standard Time (Asia/Singapore)",
    shortLabel: "SGT",
    value: "Asia/Singapore",
  },
  {
    label: "Taipei Standard Time (Asia/Taipei)",
    shortLabel: "",
    value: "Asia/Taipei",
  },
  {
    label: "Australian Western Standard Time (Australia/Perth)",
    shortLabel: "AWST",
    value: "Australia/Perth",
  },
  {
    label: "Indochina Time (Asia/Bangkok)",
    shortLabel: "ICT",
    value: "Asia/Bangkok",
  },
  {
    label: "Indochina Time (Asia/Ho_Chi_Minh)",
    shortLabel: "ICT",
    value: "Asia/Ho_Chi_Minh",
  },
  {
    label: "Western Indonesia Time (Asia/Jakarta)",
    shortLabel: "WIB",
    value: "Asia/Jakarta",
  },
  {
    label: "Myanmar Time (Asia/Rangoon)",
    shortLabel: "MST",
    value: "Asia/Rangoon",
  },
  {
    label: "Bangladesh Standard Time (Asia/Dhaka)",
    shortLabel: "BST",
    value: "Asia/Dhaka",
  },
  {
    label: "Nepal Time (Asia/Kathmandu)",
    shortLabel: "NPT",
    value: "Asia/Kathmandu",
  },
  {
    label: "India Standard Time (Asia/Kolkata)",
    shortLabel: "IST",
    value: "Asia/Kolkata",
  },
  {
    label: "India Standard Time (Asia/Colombo)",
    shortLabel: "IST",
    value: "Asia/Kolkata",
  },
  {
    label: "Pakistan Standard Time (Asia/Karachi)",
    shortLabel: "PKT",
    value: "Asia/Karachi",
  },
  {
    label: "Uzbekistan Standard Time (Asia/Tashkent)",
    shortLabel: "UZT",
    value: "Asia/Tashkent",
  },
  {
    label: "Yekaterinburg Standard Time (Asia/Yekaterinburg)",
    shortLabel: "YEKT",
    value: "Asia/Yekaterinburg",
  },
  {
    label: "Afghanistan Time (Asia/Kabul)",
    shortLabel: "AFT",
    value: "Asia/Kabul",
  },
  {
    label: "Azerbaijan Standard Time (Asia/Baku)",
    shortLabel: "AZT",
    value: "Asia/Baku",
  },
  {
    label: "Gulf Standard Time (Asia/Dubai)",
    shortLabel: "GST",
    value: "Asia/Dubai",
  },
  {
    label: "Georgia Standard Time (Asia/Tbilisi)",
    shortLabel: "GET",
    value: "Asia/Tbilisi",
  },
  {
    label: "Iran Standard Time (Asia/Tehran)",
    shortLabel: "IRST",
    value: "Asia/Tehran",
  },
  {
    label: "East Africa Time (Africa/Nairobi)",
    shortLabel: "EAT",
    value: "Africa/Nairobi",
  },
  {
    label: "Arabia Standard Time (Asia/Baghdad)",
    shortLabel: "AST",
    value: "Asia/Baghdad",
  },
  {
    label: "Arabia Standard Time (Asia/Kuwait)",
    shortLabel: "AST",
    value: "Asia/Kuwait",
  },
  {
    label: "Arabia Standard Time (Asia/Riyadh)",
    shortLabel: "AST",
    value: "Asia/Riyadh",
  },
  {
    label: "Europe/Istanbul",
    shortLabel: "EET",
    value: "Europe/Istanbul",
  },
  {
    label: "Moscow Standard Time (Europe/Minsk)",
    shortLabel: "MSK",
    value: "Europe/Minsk",
  },
  {
    label: "Moscow Standard Time (Europe/Moscow)",
    shortLabel: "MSK",
    value: "Europe/Moscow",
  },
  {
    label: "Eastern European Standard Time (Africa/Cairo)",
    shortLabel: "EET",
    value: "Africa/Cairo",
  },
  {
    label: "South Africa Standard Time (Africa/Johannesburg)",
    shortLabel: "SAST",
    value: "Africa/Johannesburg",
  },
  {
    label: "Eastern European Standard Time (Asia/Beirut)",
    shortLabel: "EEST",
    value: "Asia/Beirut",
  },
  {
    label: "Israel Standard Time (Asia/Jerusalem)",
    shortLabel: "IST",
    value: "Asia/Jerusalem",
  },
  {
    label: "Eastern European Standard Time (Europe/Athens)",
    shortLabel: "EET",
    value: "Europe/Athens",
  },
  {
    label: "Eastern European Standard Time (Europe/Bucharest)",
    shortLabel: "EET",
    value: "Europe/Bucharest",
  },
  {
    label: "Eastern European Standard Time (Europe/Helsinki)",
    shortLabel: "EET",
    value: "Europe/Helsinki",
  },
  {
    label: "Central European Standard Time (Africa/Algiers)",
    shortLabel: "CET",
    value: "Africa/Algiers",
  },
  {
    label: "Western European Standard Time (Africa/Casablanca)",
    shortLabel: "WET",
    value: "Africa/Casablanca",
  },
  {
    label: "Central European Standard Time (Europe/Amsterdam)",
    shortLabel: "CET",
    value: "Europe/Amsterdam",
  },
  {
    label: "Central European Standard Time (Europe/Berlin)",
    shortLabel: "CET",
    value: "Europe/Berlin",
  },
  {
    label: "Central European Standard Time (Europe/Brussels)",
    shortLabel: "CET",
    value: "Europe/Brussels",
  },
  {
    label: "Central European Standard Time (Europe/Paris)",
    shortLabel: "CET",
    value: "Europe/Paris",
  },
  {
    label: "Central European Standard Time (Europe/Prague)",
    shortLabel: "CET",
    value: "Europe/Prague",
  },
  {
    label: "Central European Standard Time (Europe/Rome)",
    shortLabel: "CET",
    value: "Europe/Rome",
  },
  {
    label: "Irish Standard Time (Europe/Dublin)",
    shortLabel: "IST",
    value: "Europe/Dublin",
  },
  {
    label: "Western European Standard Time (Europe/Lisbon)",
    shortLabel: "WET",
    value: "Europe/Lisbon",
  },
  {
    label: "Greenwich Mean Time (Europe/London)",
    shortLabel: "GMT",
    value: "Europe/London",
  },
  {
    label: "Greenwich Mean Time (GMT)",
    shortLabel: "GMT",
    value: "GMT",
  },
  {
    label: "East Greenland Standard Time (America/Scoresbysund)",
    shortLabel: "EGT",
    value: "America/Scoresbysund",
  },
  {
    label: "Azores Standard Time (Atlantic/Azores)",
    shortLabel: "AZOT",
    value: "Atlantic/Azores",
  },
  {
    label: "Cape Verde Standard Time (Atlantic/Cape_Verde)",
    shortLabel: "CVT",
    value: "Atlantic/Cape_Verde",
  },
  {
    label: "South Georgia Time (Atlantic/South_Georgia)",
    shortLabel: "GST",
    value: "Atlantic/South_Georgia",
  },
  {
    label: "Argentina Standard Time (America/Argentina/Buenos_Aires)",
    shortLabel: "ART",
    value: "America/Argentina/Buenos_Aires",
  },
  {
    label: "Chile Summer Time (America/Santiago)",
    shortLabel: "CLT",
    value: "America/Santiago",
  },
  {
    label: "Brasilia Standard Time (America/Sao_Paulo)",
    shortLabel: "BRT",
    value: "America/Sao_Paulo",
  },
  {
    label: "Newfoundland Standard Time (America/St_Johns)",
    shortLabel: "NST",
    value: "America/St_Johns",
  },
  {
    label: "Venezuela Time (America/Caracas)",
    shortLabel: "VET",
    value: "America/Caracas",
  },
  {
    label: "Atlantic Standard Time (America/Halifax)",
    shortLabel: "AST",
    value: "America/Halifax",
  },
  {
    label: "Atlantic Standard Time (America/Puerto_Rico)",
    shortLabel: "AST",
    value: "America/Puerto_Rico",
  },
  {
    label: "Atlantic Standard Time (Atlantic/Bermuda)",
    shortLabel: "AST",
    value: "Atlantic/Bermuda",
  },
  {
    label: "Colombia Standard Time (America/Bogota)",
    shortLabel: "COT",
    value: "America/Bogota",
  },
  {
    label: "Eastern Standard Time (America/Indiana/Indianapolis)",
    shortLabel: "EST",
    value: "America/Indiana/Indianapolis",
  },
  {
    label: "Peru Standard Time (America/Lima)",
    shortLabel: "PET",
    value: "America/Lima",
  },
  {
    label: "Eastern Standard Time (America/New_York)",
    shortLabel: "EST",
    value: "America/New_York",
  },
  {
    label: "Eastern Standard Time (America/Panama)",
    shortLabel: "EST",
    value: "America/Panama",
  },
  {
    label: "Central Standard Time (America/Chicago)",
    shortLabel: "CST",
    value: "America/Chicago",
  },
  {
    label: "Central Standard Time (America/El_Salvador)",
    shortLabel: "CST",
    value: "America/El_Salvador",
  },
  {
    label: "Central Standard Time (America/Mexico_City)",
    shortLabel: "CST",
    value: "America/Mexico_City",
  },
  {
    label: "Mountain Standard Time (America/Denver)",
    shortLabel: "MST",
    value: "America/Denver",
  },
  {
    label: "Mexican Pacific Standard Time (America/Mazatlan)",
    shortLabel: "",
    value: "America/Mazatlan",
  },
  {
    label: "Mountain Standard Time (America/Phoenix)",
    shortLabel: "MST",
    value: "America/Phoenix",
  },
  {
    label: "Pacific Standard Time (America/Los_Angeles)",
    shortLabel: "PST",
    value: "America/Los_Angeles",
  },
  {
    label: "Pacific Standard Time (America/Tijuana)",
    shortLabel: "PST",
    value: "America/Tijuana",
  },
  {
    label: "Pitcairn Time (Pacific/Pitcairn)",
    shortLabel: "PST",
    value: "Pacific/Pitcairn",
  },
  {
    label: "Alaska Standard Time (America/Anchorage)",
    shortLabel: "AKST",
    value: "America/Anchorage",
  },
  {
    label: "Gambier Time (Pacific/Gambier)",
    shortLabel: "GAMT",
    value: "Pacific/Gambier",
  },
  {
    label: "Marquesas Time (Pacific/Marquesas)",
    shortLabel: "MART",
    value: "Pacific/Marquesas",
  },
  {
    label: "Hawaii-Aleutian Standard Time (America/Adak)",
    shortLabel: "HST",
    value: "America/Adak",
  },
  {
    label: "Hawaii-Aleutian Standard Time (Pacific/Honolulu)",
    shortLabel: "HST",
    value: "Pacific/Honolulu",
  },
  {
    label: "Niue Time (Pacific/Niue)",
    shortLabel: "NUT",
    value: "Pacific/Niue",
  },
  {
    label: "Samoa Standard Time (Pacific/Pago_Pago)",
    shortLabel: "SST",
    value: "Pacific/Pago_Pago",
  },
];
